import RoomLayout from "/components/shared/layouts/RoomLayout.jsx";
import RoomBox from "/components/shared/layouts/RoomBox";
import { fetchProductions } from '/api/productions';
import { flattenProductionsToShows } from '/utils';
import TicketWidget from '/components/shared/TicketWidget/TicketWidget';
import { find } from 'lodash';
import {motion} from "framer-motion";

export default function Tickets({ show, ticketing_base_url }) {
    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
          <motion.div
            initial={{opacity: 0, translateY: 500}}
            animate={{opacity: 1, translateY: 0}}
            exit={{opacity: 0, scale: 0.5}}
            className={`relative flex flex-col w-[90vw] 2xl:w-[70vw] h-[80vh] bg-white overflow-hidden rounded-[16px]`}>
            <TicketWidget ticketing_base_url={ticketing_base_url} slug={show.stream?.ticket_sale?.slug}></TicketWidget>
          </motion.div>
        </RoomLayout>
    );
}

export async function getStaticPaths() {
    const productions = await fetchProductions();
    const paths = flattenProductionsToShows(productions).map(show => ({params: {slug: show.slug}}));
    return {
        paths,
        fallback: 'blocking'
    };
}

export async function getStaticProps(context) {
    const productions = await fetchProductions();
    const show = find(flattenProductionsToShows(productions), {slug: context.params.slug});
    
    return {
        props: {
            ticketing_base_url: process.env.TICKETING_BASE_URL,
            show,
            productions
        },
        revalidate: 60
    };
}

